export default "/logo.7f51ba315837387eda6041e090e3474b.svg";